<template>
	<div>
		<NavBar :admin="true" :items="items" />
		<v-main>
			<v-container>
				<p class="text-h5 mt-2" v-translate>FAQ</p>
				<v-btn small fab class="mb-3" color="primary" @click="showNewQuestionForm = !showNewQuestionForm">
					<v-icon>mdi-plus</v-icon>
				</v-btn>
				<template v-if="showNewQuestionForm">
					<v-form ref="newQuestionForm" v-model="validForm">
						<v-row no-gutters>
              <v-col cols="12">
								Pergunta PT
								<RichTextEditor key="pt-title" ref="questionPT" :text="newQuestion.question_pt" />
							</v-col>
              <v-col cols="12">
								Pergunta EN
								<RichTextEditor key="en-title" ref="questionEN" :text="newQuestion.question_en" />
							</v-col>
              <v-col cols="12">
								Pergunta ES
								<RichTextEditor key="es-title" ref="questionES" :text="newQuestion.question_es" />
							</v-col>
							<v-col cols="12" class="mt-10">
								Resposta PT
								<RichTextEditor key="pt-text" ref="answerPT" :text="newQuestion.answer_pt" />
							</v-col>
							<v-col cols="12">
								Resposta EN
								<RichTextEditor key="en-text" ref="answerEN" :text="newQuestion.answer_en" />
							</v-col>
							<v-col cols="12">
								Resposta ES
								<RichTextEditor key="es-text" ref="answerES" :text="newQuestion.answer_es" />
							</v-col>
              <v-col cols="12" md="4" class="mt-10">
								<v-select
									v-model="newQuestion.topic_id"
									:items="topics"
									:label="$gettext('Topic')"
									item-text="name_pt"
									item-value="id"
									outlined
									:rules="[required]"
                  no-data-text="Não existem tópicos criados."
								></v-select>
							</v-col>
							<v-col cols="6" class="mt-10">
								<v-file-input
									accept="image/png, image/jpeg, image/bmp"
									label="Imagem"
									v-model="imageUpload"
									outlined
									class="px-2"
									hide-details
								></v-file-input>
							</v-col>
						</v-row>
					</v-form>
					<v-row no-gutters class="mb-4">
						<v-spacer></v-spacer>
						<v-btn color="primary" class="mb-2" @click="addQuestion">
							<translate>Add</translate>
						</v-btn>
					</v-row>
				</template>
				<v-progress-linear v-if="loading" indeterminate color="primary"></v-progress-linear>
        <!-- <QuestionAnswer v-else v-for="question in questions" :key="question.id" @delete-question="deleteQuestion" @edit-question="editQuestion" :question="question" :topics="topics" /> -->
        <draggable v-else tag="div" v-model="draggableCards">
					<template v-for="question in questions">
						<QuestionAnswer :key="question.id" @delete-question="deleteQuestion" @edit-question="editQuestion" :question="question" :topics="topics" />
					</template>
				</draggable>
				<v-row no-gutters class="mt-3">
					<v-spacer></v-spacer>
					<v-btn v-if="orderChanged" @click="saveOrder" text class="mb-3" color="primary">
						<translate>Save Order</translate>
					</v-btn>
				</v-row>
				<p class="text-h5 mt-5" v-translate>Topics</p>
				<v-btn small fab class="mb-3" color="primary" @click="showNewTopicForm = !showNewTopicForm">
					<v-icon>mdi-plus</v-icon>
				</v-btn>
        <template v-if="showNewTopicForm">
          <v-form ref="newTopicForm">
            <v-row no-gutters>
              <v-col cols="12">
								<v-text-field
									:rules="[required]"
									v-model="newTopic.name_pt"
									:label="$gettext('Name') + ' PT'"
									outlined
								></v-text-field>
							</v-col>
              <v-col cols="12">
								<v-text-field
									:rules="[required]"
									v-model="newTopic.name_en"
									:label="$gettext('Name') + ' EN'"
									outlined
								></v-text-field>
							</v-col>
              <v-col cols="12">
								<v-text-field
									:rules="[required]"
									v-model="newTopic.name_es"
									:label="$gettext('Name') + ' ES'"
									outlined
								></v-text-field>
							</v-col>
            </v-row>
          </v-form>
          <v-row no-gutters class="mb-4">
						<v-spacer></v-spacer>
						<v-btn color="primary" class="mb-2" @click="addTopic">
							<translate>Add</translate>
						</v-btn>
					</v-row>
        </template>
        <v-progress-linear v-if="loading" indeterminate color="primary"></v-progress-linear>
        <Topic v-else v-for="topic in topics" :key="'topic' + topic.id" :topic="topic" @delete-topic="deleteTopic" @edit-topic="editTopic" />
			</v-container>
		</v-main>
	</div>
</template>

<script>
import NavBar from "@/components/authentication/NavBar.vue";
import QuestionAnswer from "@/components/admin/QuestionAnswer.vue";
import Topic from "@/components/admin/Topic.vue";
import axios from "axios";
import RichTextEditor from "@/components/RichTextEditor.vue";
import draggable from "vuedraggable";

export default {
  name: "QuestionAnswers",
  components: {
    NavBar,
		QuestionAnswer,
    RichTextEditor,
		Topic,
		draggable
	},
	data: () => ({
    questions: [],
    showNewQuestionForm: false,
    showNewTopicForm: false,
		newQuestion: {
      question_pt: "",
      question_en: "",
      question_es: "",
			answer_pt: "",
			answer_en: "",
      answer_es: "",
      topic_id: null
    },
    newTopic: {
      name_pt: "",
      name_en: "",
      name_es: ""
    },
		validForm: false,
		loading: true,
		imageUpload: null,
		orderChanged: false
	}),
	computed: {
		items() {
			return [
				{
					text: this.$gettext("Dashboard"),
					disabled: false,
					link: true,
					to: "/admin/dashboard"
				},
				{
					text: this.$gettext("FAQ"),
					disabled: true,
					link: true
				}
			];
    },
    required() {
			return value => !!value || this.$gettext("Required.");
		},
		draggableCards: {
      get() {
        return this.questions;
      },
      set(val) {
				this.questions = val;
				this.orderChanged = true;
      }
    }
  },
  methods: {
    addQuestion() {
      if (this.$refs.newQuestionForm.validate()) {
				const form = new FormData();
        form.append("question_pt", this.$refs.questionPT.getHTML());
        form.append("question_en", this.$refs.questionEN.getHTML());
        form.append("question_es", this.$refs.questionES.getHTML());
				form.append("answer_pt", this.$refs.answerPT.getHTML());
				form.append("answer_en", this.$refs.answerEN.getHTML());
        form.append("answer_es", this.$refs.answerES.getHTML());
        form.append("topic_id", this.newQuestion.topic_id);
				form.append("image_upload", this.imageUpload);
				form.append("list_order", this.questions.length);
				axios
					.post("/admin/question-answers/new", form)
					.then(response => {
						console.log(response.data);
						if (response.data.result == "ok") {
              this.questions.push(response.data.question);
              this.newQuestion.question_pt = "";
              this.newQuestion.question_en = "";
              this.newQuestion.question_es = "";
							this.newQuestion.answer_pt = "";
							this.newQuestion.answer_en = "";
              this.newQuestion.answer_es = "";
              this.newQuestion.topic_id = null;
							this.showNewQuestionForm = false;
							this.imageUpload = null;
						}
					})
					.catch(error => console.log(error));
      }
    },
    editQuestion(question) {
      let q = this.questions.find(q => q.id === question.id);
      Object.assign(q, question);
    },
    deleteQuestion(question) {
      this.questions.splice(this.questions.indexOf(question), 1);
    },
    addTopic() {
      if (this.$refs.newTopicForm.validate()) {
				const form = new FormData();
        form.append("name_pt", this.newTopic.name_pt);
        form.append("name_en", this.newTopic.name_en);
        form.append("name_es", this.newTopic.name_es);
				axios
					.post("/admin/question-answers-topics/new", form)
					.then(response => {
						console.log(response.data);
						if (response.data.result == "ok") {
              this.topics.unshift(response.data.topic);
              this.newTopic.name_pt = "";
              this.newTopic.name_en = "";
              this.newTopic.name_es = "";
							this.showNewTopicForm = false;
						}
					})
          .catch(error => console.log(error));
      }
    },
    editTopic(topic) {
      let t = this.topics.find(t => t.id === topic.id);
      Object.assign(t, topic);
    },
    deleteTopic(topic) {
      console.log("delete topic");
      this.topics.splice(this.topics.indexOf(topic), 1);
		},
		saveOrder() {
			let data = [];
			for(let i = 0; i < this.questions.length; i++) {
				data.push(this.questions[i].id);
			}
			console.log(data);
			axios
				.post("/admin/question-answers/save-order", data)
				.then(response => {
					console.log(response.data);
          this.orderChanged = false;
				})
				.catch(error => console.log(error));
    }
  },
  created() {
		axios
			.get("/admin/question-answers")
			.then(response => {
        console.log(response.data);
				if (response.status === 200) {
          this.questions = response.data.questions;
          this.topics = response.data.topics;
					this.loading = false;
				}
			})
			.catch(error => console.log(error));
  }
};
</script>